import React from "react";
import styled from "styled-components";
import Select from "react-select";

const selectStyles = {
  menu: (styles) => ({ ...styles, zIndex: 999 }),
};

const SelectContainer = styled.div``;
const ErrorContainer = styled.div`
  padding: 8px 4px 0px 4px;
`;
const ErrorMessage = styled.div`
  color: #eb445a;
`;

let FormSelect = (props) => {
  const { value, onChange, onError } = props.input;

  const errorContainer = (
    <ErrorContainer>
      <ErrorMessage>{props.meta && props.meta.error}</ErrorMessage>
    </ErrorContainer>
  );

  return (
    <SelectContainer>
      <Select
        onChange={onChange}
        onError={onError}
        value={value}
        options={props.options}
        {...props}
        styles={selectStyles}
        isDisabled={props.disabled}
      />
      {props.meta &&
        props.meta.error &&
        props.meta.submitFailed &&
        errorContainer}
    </SelectContainer>
  );
};

export default FormSelect;
